import { render } from "./ProfileImageSmall.vue?vue&type=template&id=378ad3e3"
import script from "./ProfileImageSmall.vue?vue&type=script&lang=js"
export * from "./ProfileImageSmall.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\khurr\\OneDrive\\desktop\\development\\refinedhealthpros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__